module.exports = __webpack_public_path__ + "img/visage90.cb16e7ee.png";